
import { TType, TSkeletonHeight } from './types'
import props from './props'
import Skeleton from '~/components/utils/skeleton/index.vue'

function buildFontClassNames(type: TType, underline: boolean): string {
  const underlineClass = underline ? 'underline' : ''
  const fontSize = {
    h1: `text-xl lg:text-4xl`,
    h2: `text-lg lg:text-xl`,
    h3: `text-lg lg:text-2lg`,
    h4: `text-base lg:text-lg ${underlineClass}`,
    h5: `text-xs ${underlineClass}`,
    modal: `text-xl`,
  }
  return fontSize[type]
}

function buildLineHeightClassNames(type: TType, leadingNone: boolean): string {
  if (leadingNone) {
    return 'leading-none'
  }

  const lineHeight = {
    h1: `leading-tight md:leading-snug`,
    h2: `leading-relaxed lg:leading-loose`,
    h3: `leading-exceeding lg:leading-relaxed`,
    h4: `leading-normal`,
    h5: `leading-relaxed`,
    modal: `leading-tight`,
  }
  return lineHeight[type]
}

function buildFontWeightClassNames(type: TType, light: boolean) {
  if (type === 'h1' || type === 'h2') {
    return light ? 'font-medium' : 'font-semibold'
  }

  if (type === 'h3') return light ? 'font-normal' : 'font-semibold'

  if (type === 'modal') return 'font-bold'

  return light ? 'font-light' : 'font-medium'
}

export default {
  name: 'Title',
  components: {
    Skeleton,
  },
  props,
  data() {
    const { type, underline, leadingNone, light } = this
    return {
      fontSizeClassNames: buildFontClassNames(type, underline),
      fontWeightClassNames: buildFontWeightClassNames(type, light),
      lineHeightClassNames: buildLineHeightClassNames(type, leadingNone),
    }
  },
  computed: {
    tagName(): 'p' | TType {
      // Use HTML tag always if its defined
      if (this.htmlTag) return this.htmlTag
      return this.isParagraph || this.type === 'modal' ? 'p' : this.type
    },
    skeletonHeight(): TSkeletonHeight {
      const { type } = this
      const heightByType = {
        h1: '8',
        h2: '6',
        h3: '5',
        h4: '4',
      }

      return heightByType[type]
    },
  },
  render(createElement) {
    const {
      $slots,
      color,
      fontSizeClassNames,
      lineHeightClassNames,
      tagName,
      fontWeightClassNames,
      skeleton,
      skeletonHeight,
      skeletonWidth,
    } = this

    if (skeleton) {
      return createElement('skeleton', {
        props: {
          width: skeletonWidth,
          height: skeletonHeight,
        },
      })
    }

    const attributes = {
      class: [
        'm-0',
        `text-${color}`,
        fontSizeClassNames,
        fontWeightClassNames,
        lineHeightClassNames,
      ],
    }

    return createElement(tagName, attributes, $slots.default)
  },
}
